import React from 'react';
import { FormFieldConf, SelectTypes, InputTypes } from 'components/common/forms/helpers';
import { OptionItem } from 'interfaces/OptionItem';
import { FormInput } from './fields/FormInput';
import { FormSelect } from './fields/FormSelect';
import { FormControl } from './fields/FormControl';

interface FormFieldProps {
  field: FormFieldConf<string>;
  options?: OptionItem[];
  disabled?: boolean;
  hidden?: boolean;
  mask?: string;
  style?: React.CSSProperties;
  noStyle?: boolean;
  allowClear?: boolean;
  onSearch?: (value: string) => void;
}

export const FormField: React.FC<FormFieldProps> = ({ field, mask, allowClear, onSearch, children, ...props }) => {
  const options = field.options || props.options;
  const hasOptions = options && true;
  const hasChildren = children && true;
  let control = null;

  if (hasOptions) {
    const type = field.type as SelectTypes;
    control =
      <FormSelect name={field.name}
        label={field.label}
        type={type}
        placeholder={field.placeholder}
        disabled={field.disabled}
        options={options}
        rules={field.rules}
        onSearch={onSearch}
        allowClear={allowClear}
        {...props}
      />;
  }
  else if (hasChildren) {
    control = 
      <FormControl name={field.name}
        label={field.label}
        placeholder={field.placeholder}
        disabled={field.disabled}
        help={field.help}
        rules={field.rules}
      >
        {children}
      </FormControl>;
  }
  else {
    const type = field.type as InputTypes;
    control =
      <FormInput name={field.name}
        label={field.label}
        type={type}
        placeholder={field.placeholder}
        disabled={field.disabled}
        help={field.help}
        rules={field.rules}
        mask={mask}
        {...props}
      />;
  }

  return control;
};
